import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Lightbox from "./Lightbox"
import FormNewsletter from "./FormNewsletter"
import Snippet from "./Snippet"
import CtaLinkBar from "./CtaLinkBar"
import Link from "./Link"

import { media, mixins } from "../styles"
import newsletterSVG from "../images/illustrations/newsletter.svg"

const FormWrapper = styled.div`
  background: ${({ theme }) => theme.white};
  padding: 0 10px 30px;

  @media ${media.md} {
    padding: 0 35px 60px;
  }

  h2 {
    ${mixins.title4}
  }
`

const NewsletterLightbox = ({ ctaHeader }) => {
  const [showDialog, setShowDialog] = useState(false)

  const openLightbox = (e) => {
    e.preventDefault()
    setShowDialog(true)
  }
  const closeLightbox = () => setShowDialog(false)

  return (
    <div>
      <CtaLinkBar
        as={Link}
        to={Snippet({ id: "newsletterLightboxTeaser", field: "linkUrl" })}
        buttonText={Snippet({
          id: "newsletterLightboxTeaser",
          field: "linkText",
        })}
        header={
          ctaHeader ||
          Snippet({ id: "newsletterLightboxTeaser", field: "header" })
        }
        iconSize={50}
        illustration={newsletterSVG}
        intl={false}
        onClick={openLightbox}
      />
      <Lightbox
        ariaLabel={"Newsletter"}
        close={closeLightbox}
        keepOpenOnOverlayClick={true}
        show={showDialog}
      >
        <FormWrapper>
          <h2>
            <Snippet id="newsletterLightboxHeader" field="header" />
          </h2>
          <FormNewsletter />
        </FormWrapper>
      </Lightbox>
    </div>
  )
}

NewsletterLightbox.propTypes = {
  ctaHeader: PropTypes.string,
}

export default NewsletterLightbox
